import { store as Login } from './login'

import { store as Conversation } from './conversation'

import { store as Contact } from './contact'

export default { Login, Conversation, Contact }
